import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import bgimage from '../../../../images/default_staff.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditCustomer = ({ show, onClose, customerData = {}, id, onUpdated }) => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    mobile: '',
    address: '',
    pinCode: '',
    bankName: '',
    branchName: '',
    accountHolderName: '',
    accountNumber: '',
    ifscCode: '',
  });

  const [errors, setErrors] = useState({});
  const [Checked, setChecked] = useState(true);
  const [file, setFile] = useState(null);
  const imageInputRef = useRef(null);
  const BaseUrl = process.env.REACT_APP_API_BASE_URL;
  const ImgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;

  const [paymentModes, setPaymentModes] = useState([]);

  // Fetch payment modes from API
  const fetchPaymentModes = async () => {
    try {
      const response = await axios.get(`${BaseUrl}/paymentmode/getactive`);
      if (response.data && Array.isArray(response.data)) {
        setPaymentModes(response.data);
      } else {
        setPaymentModes([]);
      }
    } catch (error) {
      console.error('Failed to fetch payment modes:', error);
      setPaymentModes([]);
    }
  };

  useEffect(() => {
    fetchPaymentModes();
  }, []);

  // Initialize form when modal opens and payment modes loaded
  useEffect(() => {
    if (show && paymentModes.length) {
        console.log('customerData:', customerData);
        const selectedMode = paymentModes.find(
  (pm) => String(pm.sno) === String(customerData.payment_method)
);

      setForm({
        name: customerData.customer_name || '',
        email: customerData.customer_email || '',
        mobile: customerData.customer_number || '',
        address: customerData.address || '',
        pinCode: customerData.pincode || '',
        bankName: customerData.bank_name || '',
        branchName: customerData.branch_name || '',
        accountHolderName: customerData.account_holder_name || '',
        accountNumber: customerData.account_number || '',
        ifscCode: customerData.ifsc_code || '',
      });
      setChecked(customerData.bankInfoEnabled ?? true);
      setFile(customerData.image ? `${ImgBaseUrl}/${customerData.image}` : '');
      setErrors({});
      if (imageInputRef.current) imageInputRef.current.value = '';
    }
  }, [show, customerData, paymentModes]);


  const handleChange = (e) => {
    const { name, value } = e.target;

    // List of fields to capitalize the first letter
    const capitalizeFields = ['name', 'address','bankName' ,'branchName', 'accountHolderName'];

    const updatedValue =
      capitalizeFields.includes(name) && value.length > 0
        ? value.charAt(0).toUpperCase() + value.slice(1)
        : value;

    setForm((prev) => ({ ...prev, [name]: updatedValue }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };



  const fileHandler = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) setFile(selectedFile);
  };

  const RemoveImage = () => {
    setFile(null);
    if (imageInputRef.current) imageInputRef.current.value = '';
  };

  const handleCheckboxChange = () => {
    setChecked((prev) => !prev);
    if (Checked) {
      setErrors((prev) => ({
        ...prev,
        bankName: '',
        branchName: '',
        accountHolderName: '',
        accountNumber: '',
        ifscCode: '',
      }));
    }
  };

  // Validate form fields
 const validate = () => {
  const newErrors = {};

  if (!form.name || form.name.toString().trim() === '') newErrors.name = 'Customer Name is required';

  if (!form.email || form.email.toString().trim() === '') {
    newErrors.email = 'Email ID is required';
  } else if (!/\S+@\S+\.\S+/.test(form.email.toString().trim())) {
    newErrors.email = 'Email ID is invalid';
  }

  if (!form.mobile || form.mobile.toString().trim() === '') {
    newErrors.mobile = 'Mobile Number is required';
  } else if (!/^\d{10}$/.test(form.mobile.toString().trim())) {
    newErrors.mobile = 'Mobile Number must be exactly 10 digits';
  }

  if (!form.address || form.address.toString().trim() === '') newErrors.address = 'Address is required';

  if (!form.pinCode || form.pinCode.toString().trim() === '') {
    newErrors.pinCode = 'Pin Code is required';
  } else if (!/^\d{6}$/.test(form.pinCode.toString().trim())) {
    newErrors.pinCode = 'Pin Code must be exactly 6 digits';
  }

  if (Checked) {
    if (!form.bankName || form.bankName.toString().trim() === '') newErrors.bankName = 'Bank Name is required';
    if (!form.branchName || form.branchName.toString().trim() === '') newErrors.branchName = 'Branch Name is required';
    if (!form.accountHolderName || form.accountHolderName.toString().trim() === '') newErrors.accountHolderName = 'Account Holder Name is required';
    if (!form.accountNumber || form.accountNumber.toString().trim() === '') newErrors.accountNumber = 'Account Number is required';
    if (!form.ifscCode || form.ifscCode.toString().trim() === '') {
      newErrors.ifscCode = 'IFSC Code is required';
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(form.ifscCode.toUpperCase().trim())) {
      newErrors.ifscCode = 'Invalid IFSC Code format';
    }

  }

  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
    };



  // Submit form
  const handleSubmit = async () => {
  if (!validate()) return;

  const data = new FormData();
  data.append('customer_name', form.name);
  data.append('customer_email', form.email);
  data.append('customer_number', form.mobile);
  data.append('address', form.address);
  data.append('pincode', form.pinCode);
  data.append('bankInfoEnabled', Checked);

  if (Checked) {
    data.append('bank_name', form.bankName);
    data.append('branch_name', form.branchName);
    data.append('account_holder_name', form.accountHolderName);
    data.append('account_number', form.accountNumber);
    data.append('ifsc_code', form.ifscCode);
  }

  if (file) {
    data.append('image', file);
  }

  // Debugging: See FormData before sending
  for (let pair of data.entries()) {
    console.log(`${pair[0]}: ${pair[1]}`);
  }

  try {
    const response = await fetch(`${BaseUrl}/manage_customer/update_customer/${id}`, {
      method: 'POST',
      body: data, // ✅ Don't set content-type manually
    });

    const result = await response.json();

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Failed to update customer');
    }

    toast.success('Customer updated successfully!');
    onClose();
    onUpdated?.();
  } catch (error) {
    toast.error('Error updating customer: ' + error.message);
  }
    };


  // Helper to show error text
  const renderError = (field) =>
    errors[field] ? (
      <div className="text-danger fs-7 mt-1">{errors[field]}</div>
    ) : null;


  return (
    <Modal show={show} onHide={onClose} size="lg">
      <div className="modal-content border border-red rounded-xxl">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Update Customer</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            {/* Customer Name */}
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">
                Customer Name<span className="required">*</span>
              </label>
              <input
                type="text"
                name="name"
                className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                placeholder="Enter Name"
                value={form.name}
                onChange={handleChange}
              />
              {renderError('name')}
            </div>

            {/* Email */}
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">
                Email ID<span className="required">*</span>
              </label>
              <input
                type="email"
                name="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                placeholder="Enter Email ID"
                value={form.email}
                onChange={handleChange}
              />
              {renderError('email')}
            </div>

            {/* Mobile Number */}
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">
                Mobile Number<span className="required">*</span>
              </label>
              <input
                type="text"
                name="mobile"
                className={`form-control ${errors.mobile ? 'is-invalid' : ''}`}
                placeholder="Enter Mobile Number"
                value={form.mobile}
                maxLength={10}
                onChange={handleChange}
              />
              {renderError('mobile')}
            </div>

            {/* Address */}
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">
                Address <span className="required">*</span>
              </label>
              <textarea
                rows={1}
                name="address"
                className={`form-control ${errors.address ? 'is-invalid' : ''}`}
                placeholder="Address"
                value={form.address}
                onChange={handleChange}
              />
              {renderError('address')}
            </div>

            {/* Pin Code */}
            <div className="col-lg-6 mb-2">
              <label className="text-black font-w500 fs-7">
                Pin Code<span className="required">*</span>
              </label>
              <input
                type="text"
                name="pinCode"
                className={`form-control ${errors.pinCode ? 'is-invalid' : ''}`}
                placeholder="Enter Pin Code"
                value={form.pinCode}
                maxLength={6}
                onChange={handleChange}
              />
              {renderError('pinCode')}
            </div>

            {/* Image Upload */}
            {/* <div className="col-lg-6">
              <label className="text-black font-w500 fs-7 d-block">Image</label>
              <span className="fs-8 text-gray-800">Size: </span>
              <span className="fs-8 text-danger">15 * 15</span>
              <span className="fs-8 text-gray-800 ms-2">Format: </span>
              <span className="fs-8 text-danger">.png, .jpg</span>
              <div className="avatar-upload d-flex align-items-center">
                <div className="change position-relative">
                  <div
                    className="avatar-preview h-125px w-125px border"
                    style={{ borderRadius: '10px' }}
                  >
                  
                   <img
                    id="saveImageFile"
                    src={file ? (typeof file === 'string' ? file : URL.createObjectURL(file)) : bgimage}
                    alt={file && typeof file !== 'string' ? file.name : 'Default Avatar'}
                    className="p-1 h-125px w-125px"
                  />
                  </div>
                  <div className="change-btn">
                    <input
                      type="file"
                      id="imageUpload"
                      accept=".png, .jpg, .jpeg"
                      style={{ display: 'none' }}
                      onChange={fileHandler}
                      ref={imageInputRef}
                    />
                    <div className="mt-2 d-flex justify-content-center gap-3">
                      <Button
                        className="btn-xs mb-2"
                        variant="success"
                        onClick={() => imageInputRef.current.click()}
                      >
                        <i className="fa fa-upload color-success fs-5" />
                      </Button>
                      <Button
                        className="btn-xs mb-2"
                        variant="danger"
                        onClick={RemoveImage}
                      >
                        <i className="fa fa-close color-danger fs-5" />
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </div>

          {/* Bank Information Checkbox */}
          <div className="form-check custom-checkbox mt-3">
            <input
              type="checkbox"
              onChange={handleCheckboxChange}
              className="form-check-input me-3"
              id="customCheckBox1"
              checked={Checked}
            />
            <label
              className="text-red fs-4 font-w600 mb-3"
              htmlFor="customCheckBox1"
            >
              Bank Information
            </label>
          </div>

          {/* Bank Info Fields (conditionally rendered) */}
          {Checked && (
            <div className="row">
              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Bank Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="bankName"
                  className={`form-control ${errors.bankName ? 'is-invalid' : ''}`}
                  placeholder="Enter Bank Name"
                  value={form.bankName}
                  onChange={handleChange}
                />
                {renderError('bankName')}
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Branch Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="branchName"
                  className={`form-control ${errors.branchName ? 'is-invalid' : ''}`}
                  placeholder="Enter Branch Name"
                  value={form.branchName}
                  onChange={handleChange}
                />
                {renderError('branchName')}
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Account Holder Name<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="accountHolderName"
                  className={`form-control ${errors.accountHolderName ? 'is-invalid' : ''}`}
                  placeholder="Enter Account Holder Name"
                  value={form.accountHolderName}
                  onChange={handleChange}
                />
                {renderError('accountHolderName')}
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  Account Number<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="accountNumber"
                  className={`form-control ${errors.accountNumber ? 'is-invalid' : ''}`}
                  placeholder="Enter Account Number"
                  value={form.accountNumber}
                  onChange={handleChange}
                />
                {renderError('accountNumber')}
              </div>

              <div className="col-lg-6 mb-2">
                <label className="text-black font-w500 fs-7">
                  IFSC Code<span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="ifscCode"
                  className={`form-control ${errors.ifscCode ? 'is-invalid' : ''}`}
                  placeholder="Enter IFSC Code"
                  value={form.ifscCode}
                  onChange={handleChange}
                />
                {renderError('ifscCode')}
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button
            type="button"
            onClick={handleSubmit}
            className="btn btn-sm btn-primary"
          >
            Update Customer
            <i className="fas fa-angle-double-right ms-2"></i>
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EditCustomer;
